<template>
  <vs-prompt
    title="订单合单"
    class="combine-order"
    :active="visible"
    @close="handleCancel"
    buttonsHidden
  >
    <div>
      <div class="title">请选择需要被合并的订单，即被合并到当前选择的备选订单</div>

      <el-checkbox-group v-model="checkedType" @change="handleCheckedChange" class="check-wrap">
        <el-checkbox v-for="item in allTypes" :label="item.id" :key="item.id"
                      :style="trStyle(item.id, true)">{{item.name}}</el-checkbox>
      </el-checkbox-group>
      <gc-cmp-vs-table
        ref="table"
        multiple
        :data="tableData"
        v-model="selectedList"
        :pager="{ size: 99999 }"
        class="marTop18"
      >
        <template slot="thead">
          <vs-th
            v-for="(item, index) in tableHeader"
            :key="index"
            :style="item.width ? { width: item.width } : ''"
          >
            {{ item.name }}
          </vs-th>
        </template>
        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <template v-for="(column, indextd) in tableHeader">
                <vs-td
                  :key="indextd"
                  :style="column.width ? { width: column.width } : ''"
                >
                  <template v-if="column.key === 'buyInfo'">                    
                    <div class="buyerName">
                    {{ tr.buyerName }}
                    </div>
                    <div class="buyerType">
                    {{ tr.buyerType }}
                    </div>                               
                  </template>
                  <template v-else-if="column.key === 'receiveInfo'">                    
                    <div class="buyerName">
                    {{ tr.allAddress }}
                    </div>
                    <div class="buyerType">
                    {{ tr.receiveInfo }}
                    </div>                               
                  </template>
                  <template v-else-if="column.key === 'orderType'">
                    <div :class="orderTabClass(tr.addrMatch).className">
                      {{orderTabClass(tr.addrMatch).tabName}}
                    </div>
                  </template>
                  <template v-else-if="column.key === 'orderNo' && indextr==0">
                    {{ tr.orderNoDesc}}
                  </template>
                  <template v-else>{{ tr[column.key] }}</template>
                </vs-td>
              </template>
            </vs-tr>
          </tbody>
        </template>
      </gc-cmp-vs-table>
      <div class="footer">
        <div class="footer-tip">
          注意：收货地址不同的订单合单地址以默认订单为准
        </div>
        <vs-button
          color="primary"
          size="small"
          type="filled"
          @click="handleClick"
          >确定</vs-button
        >
      </div>
    </div>
  </vs-prompt>
</template>    

<script>
import GcCmpVsTable from "@/group-cloud/components/vsTable";
import { OrderApi } from "@/modules/server-api/commodity-sys/order";
export default {
  components: {
    GcCmpVsTable,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orderInfo: {
      type: Object,
      default: () => {}
    },
    orderNo: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      loading: false,
      allTypes: [
        {id:'all', name:'推荐合并(收货地址相同，已支付待审批订单)',tab:'推荐', color:'#00B238'},
        {id:'part', name:'中风险合并(同一买家，收货地址不同订单)', tab:'中风险', color:'#EB760B'}
      ],
      selectedList: [],
      checkedType: [],
      tableHeader: [
        {
          name: "订单编号",
          width: "120px",
          key: "orderNo",
        },
         {
          name: "订单类型",
          width: "120px",
          key: "orderType",
        },
        {
          name: "收货地址/收货人",
          width: "180px",
          key: "receiveInfo",
        },
        {
          name: "商品信息",
          width: "100px",
          key: "skuSummary",
        },
        {
          name: "买家/类型",
          width: "100px",
          key: "buyInfo",
        },
        {
          name: "订单日期",
          width: "100px",
          key: "orderTime",
        }
      ],
      tableData: [],
      allTableData: []
    };
  },
  computed: {
    
  },
  watch:{
    orderNo(value, oldValue){
      if(value && value != ''){
        this.searchCanComineList();
      }
    }
  },
  methods: {
    //筛选订单
    handleCheckedChange(type){
      //不是筛选 是选择 if(type.length > 1 || type.length == 0){
      //   this.tableData = this.allTableData;
      // }else{
      //   this.tableData = this.allTableData.filter(item => item.addrMatch == type[0])
      // }
      
      if(type.length > 1){
        this.selectedList = this.allTableData;

      }else if(type.length == 0){
        this.selectedList = [];

      }else{
        this.selectedList = [];
        let tempData = this.allTableData.filter(item => item.addrMatch == type[0]);
        if(tempData.length > 0){
          tempData.map(data => {
            const idx = this.selectedList.findIndex(select => select.orderNo == data.orderNo);
            if(idx == -1){
              this.selectedList.push(data);
            }
          });
        }
      }
    },
    //查询可以合并的订单
    searchCanComineList(){
      this.orderInfo.addrMatch = 'parent';
      let parentOrderNo = this.orderInfo.orderNo  + '(当前订单)';
      let parentInfo = {...this.orderInfo, orderNoDesc:parentOrderNo};
      this.tableData = [];
      this.allTableData = [];
      this.$vs.loading();

      OrderApi.canCombineOrder({
        orderNo: this.orderNo
      }).then(res => {
        if (res.succ == 1) {
          let resData = res.result;
          if(resData && resData.length > 0){
            //添加母订单信息
            resData.unshift(parentInfo);
            this.tableData = resData.map(item =>{
              //收货信息
              let city = item.city == '市辖区' ? '' : item.city;
              item.allAddress = item.province + city + item.area + item.address;
              let phone = item.receivePhone || '';
              let buyerName = item.receiveName || '';
              item.receiveInfo = buyerName + phone;
              //商品信息
              item.skuSummary = item.skuSummary || '';

              this.allTableData.push(item);
              return item;
            });
          }
          this.selectedList.push(this.tableData[0]);
          this.$vs.loading.close()
        } else {
          this.$vs.loading.close()
          this.$notifyError(res.error);
        }
      })  
    },
    handleCancel() {
     this.clearInfo();
     this.$emit("update:visible", false);
     this.$emit("uptOrderNo");
     this.checkedType = []
    },

    handleClick() {
      if(!this.selectedList.length){
        this.$notifyError("请选择要合并的订单");
        return;
      }else{
        let orderNos = [];
        this.selectedList.filter(item => {
          if(item.orderNo != this.orderNo){
           orderNos.push(item.orderNo);
          }
        });
        if(orderNos.length == 0){
          this.$notifyError("请选择要合并的订单");
          return;
        }else{
          this.$vs.loading();
          OrderApi.combineOrder({
           orderNo: this.orderNo,
           orderNos: orderNos
          }).then(res => {
            if (res.succ == 1) {
              // console.log('====333====', res.result);
              this.$vs.loading.close();
              this.clearInfo();
              this.$emit("success")
              this.$emit("update:visible", false);
              this.$emit("uptOrderNo");
              this.checkedType = []
            } else {
              this.$vs.loading.close();
              this.$notifyError(res.error);
            }
          })
        }  
      }
    },
    //清空参数
    clearInfo(){
      this.tableData = [];
      this.allTableData = [];
      this.selectedList = [];
      // this.orderNo = '';
    },
    //获取表格样式
    trStyle(addrMatch, isCheckouBox) {
      const currAddMatch = this.allTypes.filter(item => item.id == addrMatch);
      let styleStr = '';
      if(isCheckouBox){
        styleStr = 'margin-right: 0;'
      }
      if(currAddMatch){
        styleStr += 'color:' + currAddMatch[0].color;  
      }
      
      if(styleStr != ''){
        return styleStr;
      }
    },
    orderTabClass(addrMatch){
      const currIndex = this.allTypes.findIndex(item => item.id == addrMatch);
      let className = '';
      let tabName = '';
      switch(currIndex){
        case 0:
          className = 'combine-tab-green';
          tabName = '推荐';
          break;
        case 1:
          className = 'combine-tab-yellow';
          tabName = '中风险';
          break;
        default:
          className = 'combine-tab-gray';
          tabName = '母订单';
          break;
      }
      
      return {className: className, tabName: tabName};
    }
  }
};
</script>

<style lang="scss" scoped>

  /deep/ .vs-con-table .vs-con-tbody{
    max-height: 190px;
    overflow: auto;
  }
.combine-order {
  font-family: PingFangSC-Regular, PingFang SC;
  .check-wrap{
    display: flex;
    flex-direction: column;
    margin: 10px 0;
  }
  .title {
    font-size: 14px;
  }
  .label {
    margin-top: 20px;
    font-size: 12px;
    font-weight: 600;
  }
  /deep/ .td-check{
    width: 60px;
  }
  .buyerName {
    color: #222;
  }
  .buyerType {
    font-size: 12px;
    color: #aaa;
  }
  // .span-line {
  //   display: flex;
  //   & /deep/ .el-popover__reference-wrapper {
  //     margin-left: 2px;
  //   }
  // }
  & /deep/ .vs-dialog {
    max-width: 900px;
    height: 600px;
    min-height: 500px;
  }
  & /deep/ .vs-input--input {
    padding: 2px 4px !important;
  }
  .table-container {
    margin-top: 20px;
  }

  /deep/ .vs-dialog {
    .vs-table--content {
      height: 400px !important;
    }
    .vs-con-table .vs-con-tbody{
      max-height: 400px;
    }
  }

  // .pre-view {
  //   font-size: 12px;
  //   color: rgb(64, 144, 255);
  //   text-decoration: underline;
  // }

  .footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    color:#AAA;
  }
  .vs-table--td span {
    display: inline;
  }
  & /deep/ .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
    padding: 4px 7px;
  }
}
@mixin combine-tab($color) {
  width: 60px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border: 1px solid $color;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: $color;
}
.combine-tab-green{
  @include combine-tab(#00B238);
}

.combine-tab-yellow{
  @include combine-tab(#EB760B);
}
.combine-tab-gray{
  @include combine-tab(#AAA);
}
</style> 
